import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';

type GetExcludedStatesEndpointSpecification = ApiEndpointSpecification;
export const GetExcludedStatesEndpointSpecification: GetExcludedStatesEndpointSpecification = {
    url: '/api/champ/daylightsaving/excludedstates/:countryid',

    method: HttpMethod.GET,
    requestParamsSchemaName: 'GetExcludedStatesRequestParams',
    requestBodySchemaName: 'GetExcludedStatesRequestBody',
    okResponseSchemaName: 'GetExcludedStatesOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
};

export const invokeGetExcludedStates = Helpers.makeApiRequestFn<
    Types.GetExcludedStatesRequestParams,
    Types.GetExcludedStatesRequestBody,
    Types.GetExcludedStatesOkResponse
>(GetExcludedStatesEndpointSpecification);
